import ResizeController from '../../../assets/js/controllers/resize';

import { classesActiveAndIn, classesDelayedOut, multiAddEventListener, multiRemoveEventListener } from '../../../assets/js/helpers';

export default class GridProducts {

	static selector = 'grid-products';

	// class variables

	config = {
		animations: {
			out: {
				duration: 600
			}
		}
	};

	controllers = {
		resize: null
	};

	el = {};

	timeouts = {
		transitionOut: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			items: container.querySelectorAll(`.${this.constructor.selector}__grid-item`),
			overlayExpandCtas: container.querySelectorAll('[data-expand-cta]'),
			overlayItems: container.querySelectorAll(`.${this.constructor.selector}__grid-item.has-overlay`),
			overlayOptionButtons: container.querySelectorAll(`.${this.constructor.selector}__grid-item-overlay-options > li > button`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.overlayExpandCtas, 'click', this.#onOverlayItemButtonClick);
		multiAddEventListener(this.el.overlayOptionButtons, 'click', this.#onOverlayOptionButtonsClick);

		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.overlayExpandCtas, 'click', this.#onOverlayItemButtonClick);
		multiRemoveEventListener(this.el.overlayOptionButtons, 'click', this.#onOverlayOptionButtonsClick);

		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onOverlayItemButtonClick = (e) => {
		const $target = e.currentTarget;
		const $item = $target.closest(`.${this.constructor.selector}__grid-item`);
		const $overlay = $item.querySelector(`.${this.constructor.selector}__grid-item-overlay`);
		const $overlayOption = $overlay.querySelector(`.${this.constructor.selector}__grid-item-overlay-option`);
		const $overlayContentItem = $overlay.querySelector(`.${this.constructor.selector}__grid-item-overlay-option-content`);

		$item.classList.toggle('is-expanded');

		if (!$item.classList.contains('is-expanded')) {
			classesDelayedOut($overlay, 300);
		} else {
			classesActiveAndIn($overlay);
			if ($overlayOption) {
				classesActiveAndIn($overlayOption);
			}
			if ($overlayContentItem) {
				classesActiveAndIn($overlayContentItem);
			}
		}
	}

	#onOverlayOptionButtonsClick = (e) => {
		const $target = e.currentTarget;
		const $overlay = $target.closest(`.${this.constructor.selector}__grid-item-overlay`);
		const $overlayOptions = $overlay.querySelectorAll(`.${this.constructor.selector}__grid-item-overlay-option`);
		const $overlayOptionLast = $overlay.querySelector(`.${this.constructor.selector}__grid-item-overlay-option.is-active`);
		const $overlayContentItems = $overlay.querySelectorAll(`.${this.constructor.selector}__grid-item-overlay-option-content`);
		const $overlayContentItemLast = $overlay.querySelector(`.${this.constructor.selector}__grid-item-overlay-option-content.is-active`);

		// switch active option tab

		const $overlayOptionNext = $overlayOptions[$target.dataset.index];
		$overlayOptionLast.classList.remove('is-active');
		$overlayOptionNext.classList.add('is-active');

		// switch overlay tabbed content

		const $overlayContentItemNext = $overlayContentItems[$target.dataset.index];
		$overlayContentItemLast.classList.add('is-out');
		$overlayContentItemLast.classList.remove('is-active', 'is-in');
		$overlayContentItemNext.classList.add('is-active');

		setTimeout(() => {
			$overlayContentItemNext.classList.add('is-in');
			$overlayContentItemLast.classList.remove('is-out');
		}, 300);
	}

	// controller methods

	#onResizeUpdate = () => true;

	#onResizeRender = () => {
		for (let i = 0; i < this.el.overlayItems.length; i++) {
			const $item = this.el.overlayItems[i];
			const $overlayControls = $item.querySelector(`.${this.constructor.selector}__grid-item-overlay-controls`);
			const $overlayContent = $item.querySelector(`.${this.constructor.selector}__grid-item-overlay-options-content`);
			$overlayContent.style.paddingTop = `${$overlayControls.offsetHeight}px`;
		}
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
